import { Clip } from '../types';
import { OrderDeliveryItem } from '@features/serviceOrders/types';

export const mapClipToOrderDeliveryItem = (clip: Clip): OrderDeliveryItem => ({
    id: parseInt(clip.id, 10),
    name: clip.clipName,
    hasProxy: clip.hasProxy,
    isValid: true,
});
